import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const RemoteLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(
        `${config.API_BASE_URL}${config.WORKER.LOGIN}`,
        { email, password }
      );

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("workerID", res.data.workerID);

      sessionStorage.clear();

      navigate("/worker-home");

    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div style={container}>
      <form style={card} onSubmit={handleLogin}>
        <h2 style={title}>Worker Login</h2>
        <p style={subtitle}>Access your account</p>

        {error && <p style={errorText}>{error}</p>}

        <div style={inputGroup}>
          <label style={label}>Email</label>
          <input
            style={input}
            type="email"
            required
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div style={inputGroup}>
          <label style={label}>Password</label>
          <div style={passwordWrapper}>
            <input
              style={{ ...input, paddingRight: "42px" }}
              type={showPassword ? "text" : "password"}
              required
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={eyeIcon}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <button style={button}>Login</button>
      </form>
    </div>
  );
};

export default RemoteLogin;


/* =====================
   STYLES (MATCHES ADMIN LOGIN)
===================== */
const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #f4f9fd 0%, #ffffff 100%)",
  padding: "20px"
};

const card = {
  background: "#fff",
  padding: "40px",
  width: "100%",
  maxWidth: "400px",
  borderRadius: "16px",
  boxShadow: "0 10px 40px rgba(14, 85, 128, 0.08)",
  border: "1px solid #eef3f7",
  animation: "fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1)"
};

const title = {
  textAlign: "center",
  color: "#0E5580",
  fontSize: "2rem",
  fontWeight: "800",
  marginBottom: "8px",
  letterSpacing: "-0.01em"
};

const subtitle = {
  textAlign: "center",
  fontSize: "1rem",
  color: "#4f6475",
  marginBottom: "32px",
  lineHeight: "1.5"
};

const errorText = {
  color: "#c0392b",
  background: "#fdf2f1",
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #f0c9c4",
  marginBottom: "20px",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: "500"
};

const inputGroup = {
  marginBottom: "20px",
  display: "flex",
  flexDirection: "column"
};

const label = {
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "8px",
  color: "#12344d"
};

const input = {
  padding: "14px 16px",
  fontSize: "15px",
  borderRadius: "10px",
  border: "1px solid #cddde9",
  background: "#f9fbfd",
  transition: "border-color 0.2s, box-shadow 0.2s",
  outline: "none",
  boxSizing: "border-box",
  width: "100%",
  color: "#12344d"
};

const passwordWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "center"
};

const eyeIcon = {
  position: "absolute",
  right: "16px",
  cursor: "pointer",
  color: "#6b8396",
  fontSize: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%"
};

const button = {
  width: "100%",
  padding: "14px",
  marginTop: "12px",
  background: "#0E5580",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontSize: "16px",
  fontWeight: "600",
  cursor: "pointer",
  transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
  boxShadow: "0 4px 14px rgba(14, 85, 128, 0.2)"
};
